import React, { ChangeEvent, ReactNode, FC } from 'react'
import { WrapperCheckbox, InputCheckbox, Checkbox } from './styled'

interface ComponentProps {
	children: ReactNode
	onChange: (event: ChangeEvent<HTMLInputElement>) => void
	name: string
	className?: string
	checked: boolean
}

export const CheckboxComponent: FC<ComponentProps> = ({
	children,
	onChange,
	name,
	className,
	checked,
}) => (
	<WrapperCheckbox className={className} htmlFor={name}>
		<InputCheckbox id={name} type="checkbox" onChange={onChange} />
		<Checkbox checked={checked} />
		{children}
	</WrapperCheckbox>
)
